export default __webpack_public_path__ + "static/media/card1BK.b646688a.png";